import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { PageSpinner } from './Spinner.jsx';
import { homePathForRole, isCustomerApp } from '../lib/appTarget.js';

/**
 * Gate for member routes.
 *
 * `loading` must be waited out rather than treated as "signed out": on a cold
 * start the token is read from storage and validated against /me, and
 * redirecting during that window would bounce a legitimately signed-in user to
 * the login screen on every app launch.
 */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <PageSpinner label="Checking your session" />;

  if (!user) {
    // Remember where they were headed so login can return them there.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // The driver and admin apps have no shopper area: a member link (e.g. from a
  // notification) takes them to their own home instead of the customer screens.
  if (!isCustomerApp) return <Navigate to={homePathForRole(user.role)} replace />;

  return children ?? <Outlet />;
}
